import getApiClient from 'src/utils/getApiClient'
import type {
  LpuServicesPricesRequest,
  LpuServicesPricesResponse,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/api/apiLpuServicesPrices.types'

const apiClient = getApiClient()

const apiLpuServicesPrices = {
  get(url: string, params: LpuServicesPricesRequest) {
    return apiClient.get<LpuServicesPricesResponse>(url, { params })
  },
}

export default apiLpuServicesPrices
